import * as actionTypes from '../aciton-mgr/actionTypes';

import { errorReport as errorReportSchema, arrayOfErrorReport, normalize} from '../../helpers/schema';
import { getAjaxFunc, createActionObject } from '../../helpers/common';
import { snackBarVisiblePeriod } from '../../helpers/constants';

import * as api from '../api';

import * as strings from '../../helpers/strings';

export const submitErrorReport = errorReport => dispatch => getAjaxFunc(
  actionTypes.SUBMIT_REPORT_REQUEST,
  "",
  actionTypes.SUBMIT_REPORT_FAILURE,
  strings.msgUnknownErrorOccured,
  dispatch
)(
  () => api.createErrorReport(errorReport)
  .then(({ status, data }) => {
    switch(status){
      case 200:
        dispatch(
          createActionObject(
            actionTypes.SUBMIT_REPORT_SUCCESS,
            {
              ...normalize(data, errorReportSchema),
              message: strings.msgMessageIsSent
            }
          )
        );
        setTimeout(() => dispatch(
          createActionObject(
            actionTypes.CLOSE_SNACK_BAR
          )
        ), snackBarVisiblePeriod);
        break;
      default:
        dispatch(
          createActionObject(
            actionTypes.SUBMIT_REPORT_FAILURE,
            {
              message: strings.msgUnknownErrorOccured
            }
          )
        );
        break;
    }
  })
)()

export const closeErrorReport = errorReport => dispatch => getAjaxFunc(
  actionTypes.CLOSE_ERROR_REPORT_REQUEST,
  "",
  actionTypes.CLOSE_ERROR_REPORT_FAILURE,
  strings.msgUnknownErrorOccured,
  dispatch
)(
  () => api.closeErrorReport(errorReport.id)
  .then(({ status, data }) => {
    switch(status){
      case 200:
        dispatch(
          createActionObject(
            actionTypes.CLOSE_ERROR_REPORT_SUCCESS,
            {
              ...normalize(data, errorReportSchema),
              message: strings.msgErrorReportIsClosed
            }
          )
        );
        setTimeout(() => dispatch(
          createActionObject(
            actionTypes.CLOSE_SNACK_BAR
          )
        ), snackBarVisiblePeriod);
        break;
      default:
        dispatch(
          createActionObject(
            actionTypes.CLOSE_ERROR_REPORT_FAILURE,
            {
              message: strings.msgUnknownErrorOccured
            }
          )
        );
        break;
    }
  })
)();

export const reopenErrorReport = errorReport => dispatch => getAjaxFunc(
  actionTypes.REOPEN_ERROR_REPORT_REQUEST,
  "",
  actionTypes.REOPEN_ERROR_REPORT_FAILURE,
  strings.msgUnknownErrorOccured,
  dispatch
)(
  () => api.reopenErrorReport(errorReport.id)
  .then(({ status, data }) => {
    switch(status){
      case 200:
        dispatch(
          createActionObject(
            actionTypes.REOPEN_ERROR_REPORT_SUCCESS,
            {
              ...normalize(data, errorReportSchema),
              message: strings.msgErrorReportIsClosed
            }
          )
        );
        setTimeout(() => dispatch(
          createActionObject(
            actionTypes.REOPEN_SNACK_BAR
          )
        ), snackBarVisiblePeriod);
        break;
      default:
        dispatch(
          createActionObject(
            actionTypes.REOPEN_ERROR_REPORT_FAILURE,
            {
              message: strings.msgUnknownErrorOccured
            }
          )
        );
        break;
    }
  })
)();

export const search = criteria => dispatch => getAjaxFunc(
  actionTypes.SEARCH_REQUEST,
  "",
  actionTypes.SEARCH_FAILURE,
  strings.msgUnknownErrorOccured,
  dispatch
)(
  () => api.searchErrorReport(criteria)
  .then(({ status, message, data }) => {
    switch(status){
      case 500:
        dispatch(
          createActionObject(
            actionTypes.SEARCH_FAILURE
          )
        );
        break;
      default:
        dispatch(
          createActionObject(
            actionTypes.SEARCH_SUCCESS,
            {
              ...normalize(data.list, arrayOfErrorReport),
              totalRecord: data.totalRecord,
              totalPage: data.totalPage,
              startIndex: criteria.startIndex
            }
          )
        );
    }
  })
)();

export const selectErrorReport = errorrReportId => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_ERROR_REPORT,
    { errorrReportId }
  )
)

export const filterStatus = filterId => dispatch => dispatch(
  createActionObject(
    actionTypes.FILTER_STATUS,
    { filterId }
  )
)